module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAiCAYAAABIiGl0AAAAAXNSR0IArs4c6QAAAVBJREFUWEfFlztrwzAUhY/sbP3TN3vp1KlDCaFD6BBCyVBKCaGUUEqGTBky5H/Yckh9FKtx6St2ZN3hIsnY+rjXepxjLmb7fbIDXFggLYCULSM/Ri8HGGkG9Bgc1/r15/47vuPmrOZlPykAU0BMbDCht1vTjwo2FjLYmD4ARAOXZZbh+gCNBy4gd6sjNAqY5R0tv0I7B5erWe4X36GdgvlPx/Ofod2BLWTy9Du0EzDLO53+DQ0OLk8seRz/Dw0KTjLI8+g0aDiwhcwGp0PDgHPIy00zaAiwLK6bQ88DW8j7ZTuoA/tDO3arB24rBLh9lldnlLot2MmaDPIWfXFVmivJIa8K28kJPmY+HzYrezDpo3NkVrJX5ZLwulrlWvRCnzrrIbYQcG7j4CAUpI+3Phpij1kzexV5+2naNAS9d4s6FqayqSqmjb6b2avY1Lox/wCEgUxQdU02dwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/titleLeft.png
// module id = HJcq
// module chunks = 1